import { payrollsHomePageProps } from 'humanity/pages/payrollsHomePage/payrollsHomePage.types.js';

const PayrollsHomePage = () => {};

PayrollsHomePage.propTypes = {
  ...payrollsHomePageProps,
};

export default PayrollsHomePage;
